module.exports = __webpack_public_path__ + "img/ibis-lisboa-alfragide-hotel.56078a6c.jpg";